import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { DELETE_PLC_SAFETY_TRIGGER } from './actionTypes';
import { deletePlcSafetyTriggerSuccessful, deletePlcSafetyTriggerFailed } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* deleteTrigger({ payload: { trigger } }) {
  try {
    const response = yield call(plcSafetyAPI.deleteTrigger, trigger.token, trigger.id);
    if (response.message) {
      yield put(deletePlcSafetyTriggerSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(deletePlcSafetyTriggerFailed(error));
  }
}

export function* watchDeletePlcSafetyTrigger() {
  yield takeEvery(DELETE_PLC_SAFETY_TRIGGER, deleteTrigger);
}

function* deletePlcSafetyTriggerSaga() {
  yield all([fork(watchDeletePlcSafetyTrigger)]);
}

export default deletePlcSafetyTriggerSaga;
